module.exports = __webpack_public_path__ + "img/logo.545a216a.svg";